import { Injectable } from '@angular/core';
import { SessionAwareMultiStore } from '../../../../shared/stores/session-aware-store';
import { TerminationRequest } from '../models/termination';

@Injectable({ providedIn: 'root' })
export class TerminationsStore extends SessionAwareMultiStore<TerminationRequest> {}
